import React, { Component } from "react";
import Pagination from "../../Pagination/Pagination";

import withRouter from "../../withRouter/withRouter";
import "./Support.css";

class Support extends Component {
    constructor(props) {
        super(props);

        this.get_data = this.get_data.bind(this);
        this.on_page_change = this.on_page_change.bind(this);
    }

    on_page_change(count, page) {
        this.setState({ page });
        this.get_data(count, page);
    }

    get_data(count, page) {
        let { connection, toast } = this.props;

        connection
            .get_tickets(count, page)
            .then((res) => {
                let { tickets, page, total } = res.data;
                this.setState({ tickets, page, total });
            })
            .catch((err) => {
                toast(
                    "خطا در دریافت اطلاعات",
                    "سفارش ها بارگزاری نشدند",
                    " danger"
                );
            });
    }

    componentDidMount() {
        let { count, page } = this.state;
        this.get_data(count, page);
    }

    state = { tickets: null, total: null, page: null, count: 4 };
    render() {
        let { tickets, total, page, count } = this.state;
        return (
            <div className="SupportComponent">
                <div className="newTicket">
                    <a href="support/new" className="btn info">
                        <i className="fa-regular fa-square-plus"></i>
                        درخواست پشتیبانی جدید
                    </a>
                </div>
                <div className="tickets">
                    {tickets &&
                        tickets.length > 0 &&
                        tickets.map((ticket) => {
                            let {
                                subject,
                                readByUser,
                                status,
                                time,
                                messages,
                                id,
                            } = ticket;
                            return (
                                <div className="ticket" key={id}>
                                    <div className="subject">
                                        {subject === "other" ? (
                                            "متفرقه"
                                        ) : (
                                            <a
                                                className="text primary"
                                                href={"follow-up/" + subject}
                                            >
                                                {"سفارش شماره : " + subject}
                                            </a>
                                        )}
                                    </div>
                                    {!readByUser && (
                                        <div className="newMessage text primary">
                                            <i className="fa-regular fa-envelope">
                                                {" پیام جدید"}
                                            </i>
                                        </div>
                                    )}

                                    <div
                                        className={
                                            "status " +
                                                (status === "pending" &&
                                                    "text secondary") ||
                                            (status === "answered" &&
                                                "text primary")
                                        }
                                    >
                                        <i
                                            className={
                                                (status === "pending" &&
                                                    "fa-solid fa-spinner ") ||
                                                (status === "answered" &&
                                                    "fa-solid fa-check")
                                            }
                                        ></i>
                                        {(status === "pending" &&
                                            "در انتظار پاسخ") ||
                                            (status === "answered" &&
                                                "پاسخ داده شده")}
                                    </div>
                                    <div className="lastMessage">
                                        {messages[messages.length - 1].message}
                                    </div>
                                    <div className="actions">
                                        <a
                                            href={"support/" + id}
                                            className="respond text info"
                                        >
                                            <i className="fa-solid fa-comment-medical"></i>
                                            ارسال پیام
                                        </a>

                                        <a
                                            href={"support/" + id}
                                            className="respond text info"
                                        >
                                            <i className="fa-solid fa-eye"></i>
                                            مشاهده
                                        </a>
                                    </div>
                                </div>
                            );
                        })}
                </div>
                <div className="pagination">
                    {total && page !== null && count && (
                        <Pagination
                            count={count}
                            page={page}
                            total={total}
                            on_page_change={(p) =>
                                this.on_page_change(count, p)
                            }
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(Support);
